import baseApi from './baseApi';

export const fetchNodesApi = (data, token) => {
  return baseApi(token)
    .get(
      `/nodes?page=${data ? data.page : 0}&limit=${
        data ? data.limit : 10
      }&sort[0][key]=created&sort[0][direction]=DESC${
        data && data.searchText
          ? `&filter_groups[0][filters][0][key]=imei&filter_groups[0][filters][0][value]=${
              data.searchText
            }&filter_groups[0][filters][0][operator]=ct`
          : ''
      }`
    )
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
};

export const fetchAllNodesApi = (data, token) => {
  return baseApi(token)
    .get(
      `/nodes?page=${data ? data.page : 1}&limit=${
        data ? data.limit : 10
      }&sort[0][key]=created&sort[0][direction]=DESC&custom_options[all]=1&includes[]=agency&includes[]=gateways${
        data && data.searchText
          ? `&filter_groups[0][filters][0][key]=imei&filter_groups[0][filters][0][value]=${
              data.searchText
            }&filter_groups[0][filters][0][operator]=ct`
          : ''
      }`
    )
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
};

export const createNodeApi = (token, node) => {
  const payload = {
    node: {
      ...node
    }
  };
  return baseApi(token)
    .post('/nodes', payload)
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
};

export const updateNodeApi = (token, node) => {
  const { id } = node;
  const payload = {
    node: {
      ...node
    }
  };
  return baseApi(token)
    .put(`/nodes/${id}`, payload)
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
};

export const deleteNodeApi = (token, nodeId) => {
  return baseApi(token)
    .delete(`/nodes/${nodeId}`)
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
};

export const sellNodeApi = (token, params) =>
  baseApi(token)
    .post('/nodes/sell', params)
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
export const revokeNodesApi = (token, nodeIds) =>
  baseApi(token)
    .get(`/nodes/revoke/${nodeIds}`)
    .then(res => res)
    .catch(err => ({
      ...err,
      err: true
    }));
